import {
    Badge,
    Box,
    Button,
    FileInput,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import {
    getShortlinks,
    getUserApiKeys,
    getUsers,
} from '../../../../../http/apiClient';
import { useEffect, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../../../common';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../../../utils/roles';
import { useAuthStore } from '../../../../../store';
import { useForm } from '@mantine/form';
import useReplaceShortLink from '../../../../../http/mutations/resources/useReplaceShortLink';

const ReplaceShortLinkModal = ({ opened, close, shortLink }) => {
    const userProfile = useAuthStore((state) => state.userProfile);

    const userQueryHttpFn = (queryHttpFn, queryParams) => {
        const userId = form.values.userId;
        const searchUserRoutes = hasRole(userProfile, 'SUPER_ADMIN') && userId;

        if (searchUserRoutes) {
            return queryHttpFn({
                userId,
                pagination: queryParams,
            });
        }
        return queryHttpFn({
            pagination: queryParams,
        });
    };

    const getInitialValues = () => ({
        shortLinkId: shortLink?.id?.toString(),
        newShortLinkId: '',
    });

    const form = useForm({
        initialValues: getInitialValues(),
        validateInputOnBlur: true,
        validate: {
            newShortLinkId: (value) => {
                if (!value) {
                    return 'Select new shortlink';
                }
            },
        },
    });

    useEffect(() => {
        form.setInitialValues(getInitialValues());
        form.reset();
    }, [opened]);

    const { isPending, mutate: replaceShortLink } = useReplaceShortLink();

    const onSubmit = (model) => {
        replaceShortLink(model, {
            onSuccess(data, variables, context) {
                close();
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'md'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>
                        {shortLink
                            ? `Replace ${shortLink.domain}`
                            : 'Replace Shortlink'}
                    </Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'xs'}>
                            <SearchableSelect
                                label={'New Short Link'}
                                placeholder='Select short link to replace current with '
                                queryHttpFn={(queryParams) =>
                                    getShortlinks(queryParams)
                                }
                                queryKey={'short_links'}
                                optionsMapFn={(x) => ({
                                    label: x.domain,
                                    value: x.id.toString(),
                                })}
                                key={form.key('newShortLinkId')}
                                {...form.getInputProps('newShortLinkId')}
                            />

                            <Group justify='flex-end'>
                                <Button
                                    type={'submit'}
                                    disabled={isPending || !form.isValid()}
                                    rightSection={
                                        isPending ? (
                                            <FontAwesomeIcon
                                                icon={faSpinnerThird}
                                                spin
                                            />
                                        ) : null
                                    }>
                                    Create
                                </Button>
                            </Group>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default ReplaceShortLinkModal;
